import { render, staticRenderFns } from "./NfreshProbes.vue?vue&type=template&id=683cab8e&scoped=true&"
import script from "./NfreshProbes.vue?vue&type=script&lang=ts&"
export * from "./NfreshProbes.vue?vue&type=script&lang=ts&"
import style0 from "./NfreshProbes.vue?vue&type=style&index=0&id=683cab8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683cab8e",
  null
  
)

export default component.exports